/**
 * The two fields people type inconsistently.
 *
 * <p>Applied as they type rather than checked on save: a field that refuses a
 * letter is quicker to understand than one that complains about it afterwards.
 * The backend applies the same rules, because a screen is not the only way in.
 */

/** Digits only - a phone number has no spaces, dashes or country code here. */
export const digitsOnly = (value: string, maxLength = 15): string =>
  value.replace(/[^0-9]/g, '').slice(0, maxLength);

/** Lower case, no spaces. Gmail.Com and gmail.com are the same address. */
export const lowerEmail = (value: string): string => value.replace(/\s/g, '').toLowerCase();
